import { render, staticRenderFns } from "./watermark.vue?vue&type=template&id=195407ec&scoped=true"
import script from "./watermark.vue?vue&type=script&lang=js"
export * from "./watermark.vue?vue&type=script&lang=js"
import style0 from "./watermark.vue?vue&type=style&index=0&id=195407ec&prod&lang=scss&scoped=true"
import style1 from "./watermark.vue?vue&type=style&index=1&id=195407ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195407ec",
  null
  
)

export default component.exports